// javascipt plugin for creating charts
import { Chart } from 'chart.js';
import React, { createRef } from 'react';

// core components
import {
  chartOptions,
  initializePolyFill,
  parseOptions,
} from '../../../variables/charts';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class ScoringHistoryChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popCanvas: null,
      graphic: null,
      currentData: null,
      loadPage: true,
    };
    this.canvasRef = createRef();
  }

  getGradienYDisplacement(maxData, data, canvasHeight) {
    const ptsCanvas = (data * canvasHeight) / maxData; // bar higth
    const quarterPtsCanvas = ptsCanvas / 4;
    const emtySpace = ptsCanvas - canvasHeight; // space on over bar
    const gradientYDisplacement = emtySpace - quarterPtsCanvas;
    return gradientYDisplacement;
  }

  paintBar(maxData, data, canvasHeight, chartCanvas) {
    const gradientYDisplacement = this.getGradienYDisplacement(
      maxData,
      data,
      canvasHeight,
    );
    const GradientBar = chartCanvas.createLinearGradient(
      0,
      -gradientYDisplacement,
      0,
      canvasHeight,
    );
    GradientBar.addColorStop(0, '#15457E');
    GradientBar.addColorStop(1, '#1960B2');
    return GradientBar;
  }

  setChartDatasetsBar(canvasHeight, bar_ctx) {
    const dayScore = [
      this.props.weekScore.m,
      this.props.weekScore.tu,
      this.props.weekScore.w,
      this.props.weekScore.th,
      this.props.weekScore.f,
      this.props.weekScore.sa,
      this.props.weekScore.su,
    ];
    const maxScore = Math.max(...dayScore) + 1;
    const datasets = {
      type: 'bar',
      yAxesGroup: '1',
      xAxesGroup: '1',
      label: 'PTS',
      data: [
        dayScore[0],
        dayScore[1],
        dayScore[2],
        dayScore[3],
        dayScore[4],
        dayScore[5],
        dayScore[6],
      ],
      backgroundColor: [
        this.paintBar(maxScore, dayScore[0] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[1] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[2] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[3] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[4] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[5] + 1, canvasHeight, bar_ctx),
        this.paintBar(maxScore, dayScore[6] + 1, canvasHeight, bar_ctx),
      ],
      borderWidth: 0,
    };
    return datasets;
  }

  setChartDatasetsAverage() {
    const datasets = {
      type: 'line',
      label: 'Average',
      data: [
        this.props.average,
        this.props.average,
        this.props.average,
        this.props.average,
        this.props.average,
        this.props.average,
        this.props.average,
      ],
      borderColor: '#D6083B',
      borderWidth: 2,
      borderDash: [10, 5],
      fill: false,
      backgroundColor: '#D6083B',
      strokeStyle: '#15457E',
    };
    return datasets;
  }

  buildChart() {
    const canvasElement = this.canvasRef.current;
    if (!canvasElement) return;

    const canvasHeight = canvasElement.clientHeight - 80;
    const bar_ctx = canvasElement.getContext('2d');

    const existingChart = Chart.getChart(bar_ctx);
    if (existingChart) {
      existingChart.destroy();
    }

    const datasetsBar = this.setChartDatasetsBar(canvasHeight, bar_ctx);
    const datasetsAverage = this.setChartDatasetsAverage();
    const scoringHistory = new Chart(bar_ctx, {
      type: 'bar',
      data: {
        datasets: [datasetsBar, datasetsAverage],
      },
      options: {
        scales: {
          y: {
            position: 'right',
            grid: {
              display: true,
              lineWidth: 1,
              offset: false,
              borderDash: [5, 0],
            },
          },
          x: {
            maxBarThickness: 15,
            ticks: {
              beginAtZero: false,
            },
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
          },
        },
        legend: {
          onClick: null,
          display: true,
          labels: {
            fontColor: '#1C3B60',
            text: '',
          },
          position: 'bottom',
        },
      },
    });
    this.setState({ graphic: scoringHistory });
  }

  UNSAFE_componentWillMount() {
    if (window.Chart) {
      parseOptions(Chart, chartOptions());
    }
  }

  async componentDidMount() {
    const loadPoly = await initializePolyFill();
    if (loadPoly) {
      this.setState({ loadPage: false }, () => {
        this.buildChart();
      });
    }
  }

  componentDidUpdate() {
    if (this.state.currentData !== this.props.weekScore) {
      this.setState({ currentData: this.props.weekScore });
      const graphic = this.state.graphic;
      if (graphic) {
        graphic.destroy();
        this.buildChart();
      }
    }
  }

  render() {
    return (
      <>
        {!this.state.loadPage ? (
          <div>
            <canvas
              ref={this.canvasRef}
              id="scoringHistoryChart"
              height={300}
              className="chart-canvas"
            />
          </div>
        ) : (
          <CircularLoading className="loading-subscription-gif" />
        )}
      </>
    );
  }
}

export default ScoringHistoryChart;
